import { render, staticRenderFns } from "./lista-mini.vue?vue&type=template&id=2b9427d8&scoped=true&"
import script from "./lista-mini.vue?vue&type=script&lang=ts&"
export * from "./lista-mini.vue?vue&type=script&lang=ts&"
import style0 from "./lista-mini.vue?vue&type=style&index=0&id=2b9427d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9427d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VDivider,VList,VListItemGroup})
